import React from "react";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import { Autocomplete, backdropClasses, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from '@mui/material/styles';

export const StyledAutocompleteBlue = styled(Autocomplete)({
	'& label.Mui-focused': {
		color: `rgba(73 , 148, 236, 0.875)`,
    // opacity: 0,
	},
  '&:hover label.Mui-focused': {
		color: `rgba(73 , 148, 236, 0.875)`,
    // opacity: 0,
	},
	'& .MuiOutlinedInput-root': {
		'& fieldset': {
			borderColor: `rgba(73 , 148, 236, 0.875)`,
      // opacity: 0,
		},
		'&:hover fieldset': {
			borderColor: `rgba(73 , 148, 236, 0.875)`,
      // opacity: 0,
		},
		'&.Mui-focused fieldset': {
			borderColor: `rgba(73 , 148, 236, 0.875)`,
      // opacity: 0,
		},
	},
	'& .MuiInputLabel-root': {
		color: `rgba(73 , 148, 236, 0.875)`,
    padding: "0.1rem",
    fontSize: "0.875rem",
	},
	'& input': {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
		color: `rgba(73 , 148, 236, 0.875)`,
	},
  '& MuiInputBase-input': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
    fontSize: `0.875rem`
  },
  '& MuiAutocomplete-input': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
    fontSize: `0.875rem`
  },
  '& .MuiAutocomplete-inputRoot': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
    fontSize: `0.875rem`
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
  },
  '& .MuiInput-underline:before': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
  },
	'&:hover .MuiInput-underline:after': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
  },
  '&:hover .MuiInput-underline:before': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
  },
  '&:hover .css-16z3zeq-MuiInputBase-root-MuiInput-root': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
  },
  '&:hover .MuiInput-underline': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
  },
  '& MuiInputBase-color:before': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
  },
  '& MuiInputBase-color:after': {
    borderBottomColor: `rgba(73 , 148, 236, 0.875)`,
  },
  '& .MuiAutocomplete-popupIndicator': {
    color: `rgba(73 , 148, 236, 0.875)`,
    fontSize: "0.875rem"
  },
  '& .MuiAutocomplete-clearIndicator': {
    color: `rgba(73 , 148, 236, 0.875)`,
    fontSize: "0.875rem"
  }
});